import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import {
  FulfillmentOrderAddressSchema,
  type FulfillmentOrderAddress,
  type IFulfillmentOrderAddress,
} from "../fulfillments/fulfillment-order-address";
import { FreightLocationType } from "./freight";
import {
  DeliveryRequirementsSchema,
  FreightHandlingUnitSchema,
  FreightQuoteSchema,
  PickupRequirementsSchema,
} from "./freight-quote-request";

const PurchaseFreightBookingRequestSchema_ = z.object({
  quote: FreightQuoteSchema,
  originAddress:
    FulfillmentOrderAddressSchema as IFulfillmentOrderAddress as z.ZodType<FulfillmentOrderAddress>,
  destinationAddress:
    FulfillmentOrderAddressSchema as IFulfillmentOrderAddress as z.ZodType<FulfillmentOrderAddress>,
  pickupDateTime: z.string(),
  pickupLocationType: createEnum(FreightLocationType, {
    enumName: "FreightLocationType",
  }).nullish(),
  deliveryLocationType: createEnum(FreightLocationType, {
    enumName: "FreightLocationType",
  }).nullish(),
  pickupRequirements: PickupRequirementsSchema,
  deliveryRequirements: DeliveryRequirementsSchema,
  pickupInstructions: z.string().nullish(),
  deliveryInstructions: z.string().nullish(),
  handlingUnitList: z.array(FreightHandlingUnitSchema),
  customerReference1: z.string().nullish(),
  customerReference2: z.string().nullish(),
  specialInstructions: z.string().nullish(),
});
export const PurchaseFreightBookingRequestSchema: z.ZodType<PurchaseFreightBookingRequest> =
  PurchaseFreightBookingRequestSchema_;
export interface PurchaseFreightBookingRequest
  extends z.infer<typeof PurchaseFreightBookingRequestSchema_> {}

const PurchaseFreightBookingResponseSchema_ = z.object({
  bolUrl: z.string(),
  scac: z.string(),
  carrierName: z.string(),
  quoteId: z.string(),
  shipmentTransactionId: z.string(),
  cost: z.number(),
  bolNumber: z.string(),
  trackingLink: z.string(),
  pickupTransactionId: z.string(),
});
export const PurchaseFreightBookingResponseSchema: z.ZodType<PurchaseFreightBookingResponse> =
  PurchaseFreightBookingResponseSchema_;
export interface PurchaseFreightBookingResponse
  extends z.infer<typeof PurchaseFreightBookingResponseSchema_> {}
